module.exports = __webpack_public_path__ + "img/kademi.82bb531e.png";